import type { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import {
  faAndroid,
  faApple,
  faChrome,
  faLinux,
  faWindows,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { Chip } from '@feathr/components';

enum Platforms {
  android = 'Android',
  chromeos = 'ChromeOS',
  ipad = 'iPad',
  iphone = 'iPhone',
  linux = 'Linux',
  macos = 'OSX',
  windows = 'Windows',
}

export interface IProps {
  platform: keyof typeof Platforms;
}

const IconMap: Record<keyof typeof Platforms, IconDefinition> = {
  android: faAndroid,
  chromeos: faChrome,
  ipad: faApple,
  iphone: faApple,
  linux: faLinux,
  macos: faApple,
  windows: faWindows,
};

function PlatformChip({ platform }: IProps) {
  const platformIcon = IconMap[platform];

  return (
    <Chip prefix={platformIcon ? <FontAwesomeIcon icon={platformIcon} /> : undefined}>
      {Platforms[platform] || 'Other'}
    </Chip>
  );
}

export default observer(PlatformChip);
